import * as TYPES from './types';

const namespaced = true;

const state = () => ({
  refuseModal: {
    bg: false,
    modal: false,
  },
  modalImage: {
    bg: false,
    modal: false,
    title: '',
    image: '',
  },
});

const actions = {
};

const mutations = {
  [TYPES.SET_REFUSE_MODAL](state, payload) {
    if (payload) {
      for (const key in payload) {
        state.refuseModal[key] = payload[key];
      }
    }
  },

  [TYPES.SET_MODAL_IMAGE](state, payload) {
    if (payload) {
      for (const key in payload) {
        state.modalImage[key] = payload[key];
      }
    }
  },
};

export default {
  namespaced,
  actions,
  state,
  mutations,
};
